import { render, staticRenderFns } from "./OtherImaging.vue?vue&type=template&id=6b9e3ea0&scoped=true&"
import script from "./OtherImaging.vue?vue&type=script&lang=js&"
export * from "./OtherImaging.vue?vue&type=script&lang=js&"
import style0 from "./OtherImaging.vue?vue&type=style&index=0&id=6b9e3ea0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9e3ea0",
  null
  
)

export default component.exports